export function getLogoUrl(logo) {
  if (typeof logo === 'string') {
    return logo;
  }
  return logo.src;
}